import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Watch } from 'scrollmonitor-react';
import FocusedImage from 'Components/FocusedImage';
import AssetModel from 'Stores/AssetModel';
import classNames from 'classnames/bind';
import { formatDate } from 'Utils/index';
import CallToAction from 'Components/CallToAction';
import styles from './styles.scss';
import { tabTypes } from 'Utils/getContactTab';
import ConsumptionData from 'Components/ConsumptionData';

const cx = classNames.bind(styles);

class ChessboardItem extends React.Component {
  static propTypes = {
    entry: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    children: PropTypes.node,
    // the (text) element of the item as html string (use either children OR content)
    content: PropTypes.string,
    className: PropTypes.string,
    flex: PropTypes.bool,
    cta: PropTypes.shape({
      additional: PropTypes.string,
      href: PropTypes.string,
      label: PropTypes.string.isRequired,
      mazdaForm: PropTypes.bool,
      model: PropTypes.string,
      type: PropTypes.oneOf(tabTypes),
      target: PropTypes.string,
    }),
    cta2: PropTypes.shape({
      additional: PropTypes.string,
      href: PropTypes.string,
      label: PropTypes.string.isRequired,
      mazdaForm: PropTypes.bool,
      model: PropTypes.string,
      type: PropTypes.oneOf(tabTypes),
      target: PropTypes.string,
    }),
    onOpenContact: PropTypes.func,
    deeplinkId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  };

  UNSAFE_componentWillReceiveProps = props => {
    if (props.isInViewport) {
      props.stopWatcher();
    }
  };

  renderCta = (cta, buttonVariant: 'primary') => {
    const { onOpenContact } = this.props;

    return (
      <div className={styles.cta}>
        <CallToAction {...cta} buttonVariant={buttonVariant} onOpenContact={onOpenContact} />
      </div>
    );
  };

  render() {
    const {
      children,
      content,
      entry,
      className,
      flex,
      cta,
      cta2,
      isInViewport,
      title,
      consumptionText,
      consumptionColorType,
      deeplinkId,
    } = this.props;
    const itemContent = children || <div dangerouslySetInnerHTML={{ __html: content }} />;
    const itemClass = cx('item', { flex, inView: window.isPreview || isInViewport });

    const image = entry.image ? new AssetModel(entry.image) : undefined;

    return (
      <Fragment>
        <div className={styles.imageItem} id={deeplinkId}>
          <div className={itemClass}>
            <div className={cx('content', className)}>
              {title && <h3 dangerouslySetInnerHTML={{ __html: title }} />}
              {itemContent}
              {cta && cta.label && this.renderCta(cta)}
              {cta2 && cta2.label && this.renderCta(cta2, 'secondary')}
            </div>
          </div>
          <div className={itemClass}>
            <div className={styles.image}>
              {(window.isPreview || isInViewport) && (
                <FocusedImage image={image} useThumb={image && image.shouldUseThumb()} />
              )}
            </div>
            {entry.isTop && (
              <div className={styles.top}>
                {entry.type === 'news' && (
                  <React.Fragment>
                    <h3>vom {formatDate(entry.datePublished)}</h3>
                    <h2 className={styles.eventNewsH1}>Top News</h2>
                  </React.Fragment>
                )}
                {entry.type === 'event' && (
                  <React.Fragment>
                    <h3>Event</h3>
                    <h2 className={styles.eventNewsH1}>
                      {formatDate(entry.startDate)}
                      <br />-<br />
                      {formatDate(entry.endDate)}
                    </h2>
                  </React.Fragment>
                )}
              </div>
            )}
          </div>
        </div>

        {consumptionText && (
          <ConsumptionData consumptionText={[consumptionText]} colorType={consumptionColorType} />
        )}
      </Fragment>
    );
  }
}

export default Watch(ChessboardItem);
